module.exports = __webpack_public_path__ + "assets/certificate.0154a1560357fe3b845a7bbeac52c650.svg";